import React from 'react'

const NoData = () => (
  <div style={{ margin: '1em' }}>
    <h2>Нет данных по заданным критериям</h2>
  </div>
)

export default NoData
